import React from 'react';
import classNames from '../../../../utility/classNames';
import CalculatedField from '../CalculatedField';

export default function LegacyCalculations({ section = {}, data }) {
  const { sectionLabel, percentageValue, annualValue, mainField, schema } =
    section;

  return (
    <div
      className={classNames(
        'w-full flex justify-between text-base items-center'
      )}
    >
      <div className="absolute rounded-t top-0 left-0 w-full h-[3px] bg-primary-400 z-10"></div>
      <div className="flex-grow space-y-2">
        <h3 className="font-semibold text-primary uppercase">{sectionLabel}</h3>

        <>
          {/* {sectionDescription && (<p>{sectionDescription}</p>)} */}
          <div className="hidden sm:grid grid-cols-5 justify-items-end font-semibold">
            <div className="col-span-2">
              <p></p>
            </div>
            <div>
              <p className="justify-self-center">{percentageValue && '%'}</p>
            </div>
            <div>
              <p>{annualValue && 'Monthly'}</p>
            </div>
            <div>
              <p>{annualValue && 'Annual'}</p>
            </div>
          </div>

          {schema.map(
            (field, index) =>
              (mainField || index !== 0) && (
                <CalculatedField
                  key={`${field.name}${index}`}
                  percentageValue={percentageValue}
                  annualValue={annualValue}
                  field={field}
                  fieldValue={data[field.name]}
                  data={data}
                  main={
                    mainField
                      ? mainField.name === field.name
                      : index === schema.length - 1
                  }
                />
              )
          )}
        </>
      </div>
    </div>
  );
}
